import React, { useState, useEffect } from 'react';
import "../style/adminpanel.css";

const AdminPanel = () => {
  const [jednostka, setJednostka] = useState('');
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeFilter, setActiveFilter] = useState('all');

  const jednostki = [
    "UG Rajcza",
    "UG Milówka",
    "UG Węgierska Górka",
    "UG Lipowa",
    "UG Ślemień",
    "UG Łękawica",
    "UG Gilowice"
  ];

  const fetchTickets = async () => {
    setLoading(true);

    try {
      const params = new URLSearchParams();
      if (jednostka) {
        params.append('jednostka', jednostka);
      }
      if (activeFilter !== 'all') {
        params.append('status', activeFilter);
      }

      const response = await fetch(`/api/get-tickets.php?${params.toString()}`);
      const data = await response.json();
      setTickets(data);
    } catch (error) {
      console.error("Błąd pobierania danych:", error);
    } finally {
      setLoading(false);
    }
  };

  const markAsImportant = async (id) => {
    try {
      await fetch(`/api/important-tickets.php?id=${id}`, {
  method: 'PUT'
})

      setTickets(prev => prev.map(ticket => ticket.id === id ? { ...ticket, important: true } : ticket));
    } catch (err) {
      console.error("Błąd oznaczania jako ważne:", err);
    }
  };

  const markAsClosed = async (id) => {
    try {
      await fetch(`/api/close-tickets.php?id=${id}`, {
  method: 'PUT'
})
      fetchTickets(); // Odświeżamy listę po zamknięciu zgłoszenia
    } catch (err) {
      console.error("Błąd zamykania zgłoszenia:", err);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, [jednostka, activeFilter]);

  return (
    <div className="admin-panel-container">
      <h1>Panel Administracyjny</h1>

      <div className="select-jednostka-container">
        <label htmlFor="jednostka">Wszystkie</label>
        <select
          id="jednostka"
          value={jednostka}
          onChange={e => setJednostka(e.target.value)}
        >
          <option value="">-- Wszystkie --</option>
          {jednostki.map((unit, index) => (
            <option key={index} value={unit}>{unit}</option>
          ))}
        </select>
      </div>

      <div className="main-content">
        <div className="sidebar">
          <button
            className={activeFilter === 'all' ? 'active' : ''}
            onClick={() => setActiveFilter('all')}
          >
            Wszystkie
          </button>
          <button
            className={activeFilter === 'open' ? 'active' : ''}
            onClick={() => setActiveFilter('open')}
          >
            Otwarte
          </button>
          <button
            className={activeFilter === 'closed' ? 'active' : ''}
            onClick={() => setActiveFilter('closed')}
          >
            Zamknięte
          </button>
        </div>

        <div className="ticket-list">
          {loading ? (
            <p>Ładowanie...</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Jednostka</th>
                  <th>Imię</th>
                  <th>Telefon</th>
                  <th>Opis</th>
                  <th>Akcje</th>
                </tr>
              </thead>
              <tbody>
                {tickets.length > 0 ? (
                  tickets.map(ticket => (
                    <tr key={ticket.id} style={{ backgroundColor: ticket.important ? '#fffc99' : '' }}>
                      <td>{ticket.jednostka}</td>
                      <td>{ticket.name}</td>
                      <td>{ticket.phone}</td>
                      <td>{ticket.description}</td>
                      <td>
                        {ticket.status !== 'closed' && (
                          <>
                            <button onClick={() => markAsImportant(ticket.id)}>
                              {ticket.important ? 'Ważne' : 'Oznacz jako ważne'}
                            </button>
                            <button onClick={() => markAsClosed(ticket.id)}>Zamknij</button>
                          </>
                        )}
                        {ticket.status === 'closed' && <span>Zamknięte</span>}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">Brak zgłoszeń do wyświetlenia.</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
